document.addEventListener("DOMContentLoaded", function () {
 let cartItemCount = 0;
    // fetch cart once on load and set global count
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
        cartItemCount = cart.items.length;
    })
    .catch(err => console.error('Cart fetch error:', err));
    // update css of progress bar in cart drawer
    updateFreeShipping = () => {
     //   if (cartItemCount > 0) {
            const eligibleAmt = parseInt(qs(".free-shipping").getAttribute("data-eligible-amt"));
            const cartTotal = parseInt(qs(".free-shipping").getAttribute("data-cart-total"));
            const progressBar = document.querySelector('.free-shipping-completed');

            if (cartTotal < eligibleAmt) {
            const percentage = (cartTotal / eligibleAmt) * 100;
            progressBar.style.width = `${percentage}%`;
            } else {
            progressBar.style.width = '100%';
            }
      //  }
    }

    // cart drawer country radio button change function
 const initCurrentSelectedCountry = () => {
  // Detect language (Arabic if RTL or lang="ar")
  const isArabic =
    document.documentElement.dir === "rtl" ||
    document.documentElement.lang === "ar";

  // Language messages
  const messages = {
    en: {
      freeApplied: "Free Shipping Applied",
      awayFromFree: (amount) =>
        `You are AED <span>${amount}</span> away from free shipping!`,
    },
    ar: {
      freeApplied: "تم تطبيق الشحن المجاني",
      awayFromFree: (amount) =>
        `أنت على بعد <span>${amount}</span> درهم من الشحن المجاني!`,
    },
  };

  const t = isArabic ? messages.ar : messages.en;

  const freeShippingEle = document.querySelector(".free-shipping");
  if (!freeShippingEle) return;

  const internationalThresoldAmount =
    freeShippingEle.getAttribute("internatioalshippingthreshold");
  const uaeThresoldAmount =
    freeShippingEle.getAttribute("uaeshippingthreshold");

  const freeShippingInner = freeShippingEle.querySelector(
    ".free-shipping-inner"
  );

  const internationalAmount =
    freeShippingInner.getAttribute("data-internationalshippingmsg");
  const uaeAmount =
    freeShippingInner.getAttribute("data-uaeshippingmessage");

  const selectedCountry = document.querySelector(
    ".delivery-country-list-body .country-list-check input:checked"
  );

  let shippingAmount = "";
  let messageHTML = "";

  if (selectedCountry) {
    const selectedCountryZone = selectedCountry.getAttribute("data-zone");
    if (selectedCountryZone === "UAE") {
      freeShippingEle.setAttribute("data-eligible-amt", uaeThresoldAmount);
      shippingAmount = uaeAmount;
    } else {
      freeShippingEle.setAttribute(
        "data-eligible-amt",
        internationalThresoldAmount
      );
      shippingAmount = internationalAmount;
    }
  } else {
    freeShippingEle.setAttribute("data-eligible-amt", uaeThresoldAmount);
    shippingAmount = uaeAmount;
  }

  // Message rendering
  if (Number(shippingAmount) < 1) {
    messageHTML = `
      <div class="shipping applied">
        ${t.freeApplied}
      </div>
    `;
  } else {
    messageHTML = `
      <div class="shipping not-applied">
        ${t.awayFromFree(shippingAmount)}
      </div>
    `;
  }

  const shippingContainer = freeShippingInner.querySelector(".shipping");
  if (shippingContainer) {
    shippingContainer.outerHTML = messageHTML;
  }

  updateFreeShipping();
};


    // get current selected country on click
   // setTimeout(initCurrentSelectedCountry, 1500);

    document.addEventListener('click', (e) => {
        const btn = e.target.closest(".quantity__button");
        if (!btn) return;

        setTimeout(initCurrentSelectedCountry, 2500);
    });

    document.addEventListener("change", (e) => {
    if (e.target.matches('.delivery-country-list-body .country-list-check input[type="radio"]')) {
        initCurrentSelectedCountry();
    }
    });

    // cart drawer change observer
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
    let debounceTimer;

    const observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
        initCurrentSelectedCountry();
        }, 500);
    });

    observer.observe(cartDrawer, {
        childList: true,
        subtree: true
    });
    }





});
